import { UserOutlined, UserSwitchOutlined } from '@ant-design/icons';
import { Timeline } from 'antd';
import Avatar from 'antd/lib/avatar/avatar';
import { getMediaStore } from 'core/modules/media/media.store';
import { getUserStore } from 'core/modules/users/user.store';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { TaskActivityLabel } from './Label';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TaskActivityAssigneeChanged = function TaskActivityAssigneeChanged(_ref) {
  var _activity$data, _activity$data2;

  var activity = _ref.activity;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getMediaStore = getMediaStore(),
      media = _getMediaStore.media,
      getUserMediaSrc = _getMediaStore.getUserMediaSrc;

  var _getUserStore = getUserStore(),
      getUserById = _getUserStore.getUserById;

  var user = getUserById(activity.authorId);
  var previousAssignee = getUserById((_activity$data = activity.data) === null || _activity$data === void 0 ? void 0 : _activity$data.previous);
  var currentAssignee = getUserById((_activity$data2 = activity.data) === null || _activity$data2 === void 0 ? void 0 : _activity$data2.current);
  return useMemo(function () {
    return /*#__PURE__*/_jsx(Container, {
      className: "ant-timeline-item-left",
      label: /*#__PURE__*/_jsx(TaskActivityLabel, {
        title: t('task.progress.assignee'),
        createdAt: activity.createdAt,
        user: user
      }),
      dot: /*#__PURE__*/_jsx(UserSwitchOutlined, {}),
      children: currentAssignee && /*#__PURE__*/_jsxs("span", {
        className: "assignee",
        children: [/*#__PURE__*/_jsx(Avatar, {
          src: getUserMediaSrc(currentAssignee.id),
          size: "small",
          icon: /*#__PURE__*/_jsx(UserOutlined, {})
        }), /*#__PURE__*/_jsx("span", {
          className: "name",
          children: currentAssignee.name
        })]
      })
    });
  }, [activity, user, previousAssignee, currentAssignee, media]);
}; // Styles

var Container = styled(Timeline.Item).withConfig({
  displayName: "AssigneeChanged__Container",
  componentId: "sc-qlzu1r-0"
})(["min-height:75px;.assignee{.name{margin-left:6px;}}"]);